<template>
  <MainTemplate>
    <div :class="$style.wrapper">
      <MainNavbar
        :has-menu="false"
        :style="{ background: 'none' }"
      />
      <div class="d-flex flex-column align-items-center">
        <b-container
          :class="[
            'd-flex flex-column align-items-center text-center',
            $style.container
          ]"
        >
          <transition
            name="fade"
            mode="out-in"
            :duration="{ enter: 1000, leave: 200 }"
          >
            <BaseLoading
              v-if="isQrCodeLoading"
              color="#fff"
            />
            <div
              v-if="!isQrCodeLoading && qrCodeLanding"
              class="d-flex flex-column align-items-center"
            >
              <router-link :to="{ name: 'home' }">
                <b-img
                  :src="require(`@/assets/images/logo-white-${$i18n.locale}.svg`)"
                  :class="[
                    'mb-4',
                    $style.logo
                  ]"
                />
              </router-link>
              <b-row
                class="d-flex justify-content-center"
              >
                <b-col
                  :cols="12"
                  :sm="8"
                  :md="6"
                  :lg="5"
                >
                  <b-img-lazy
                    :src="qrCodeLanding"
                    :blank-src="require('@/assets/images/spinner_white.svg')"
                    fluid
                  />
                </b-col>
              </b-row>
              <BaseTextH1
                :class="[
                  'mt-4',
                  $style.title
                ]"
              >
                {{ $t('wechat-landing.title') }}
              </BaseTextH1>
              <b-row class="d-flex justify-content-center">
                <b-col
                  :cols="12"
                  :sm="8"
                  :md="6"
                >
                  {{ $t('wechat-invite-widget-text') }}
                </b-col>
              </b-row>
              <div class="d-flex py-4">
                <router-link :to="{ name: isUserLoggedIn ? 'home' : 'login' }">
                  <BaseButton is-rounded>
                    <span class="px-4">{{ $t('wechat-landing.button') }}</span>
                  </BaseButton>
                </router-link>
              </div>
            </div>
          </transition>
        </b-container>
      </div>
      <MainFooter
        variant="dark"
        :style="{ background: 'none' }"
      />
    </div>
  </MainTemplate>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MainTemplate from '@/layout/Templates/MainTemplate'
import MainNavbar from '@/layout/MainNavbar'
import MainFooter from '@/layout/MainFooter'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseTextH1 from '@/components/Atoms/Typography/BaseTextH1'
import BaseLoading from '@/components/Atoms/BaseLoading'

export default {
  name: 'WechatQr',
  components: { BaseLoading, BaseTextH1, MainNavbar, MainTemplate, BaseButton, MainFooter },
  metaInfo() {
    return {
      meta: [
        { vmid: 'title', name: 'title', content: this.$t('page-titles.public-wechat-qr') },
      ],
    }
  },
  computed: {
    ...mapState({
      isUserLoggedIn: state => !!state.auth.token,
      isQrCodeLoading: state => state['qr/wechatInvite'].isQrCodeLoading,
      qrCodeLanding: state => state['qr/wechatInvite'].qrCodeLanding,
    }),
  },
  created() {
    this.fetchQrCodeLanding().then(() => {
      if (!this.qrCodeLanding) {
        this.$router.push({
          name: 'home',
        })
      }
    })
  },
  methods: {
    ...mapActions({
      fetchQrCodeLanding: 'qr/wechatInvite/fetchQrCodeLanding',
    }),
  },
}
</script>

<style module lang="scss">
  @import '../../assets/scss/variables';
  .wrapper {
    background: $color-midnight-blue url('@/assets/images/modal_bg.jpg') center center no-repeat;
    background-size: cover;
    flex: 1;
    min-width: 100vw;
    min-height: 100vh;
    color: $color-white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .container {
      flex: 1;
      justify-content: center;
      align-items: center;
    }
    .title {
      color: $color-white;
    }
    .logo {
      width: 100%;
      max-width: 200px;
      max-height: 60px;
    }
  }
</style>
